import { gql, TypedDocumentNode } from "@apollo/client";
import { isEmpty } from "@flaminem/utils";

import {
  ImportSpecificationsQuery,
  ImportSpecificationsQueryVariables,
  ImportSpecType,
} from "src/graphql/import-export/__generated__/graphql";
import { useFetchQuery } from "src/graphql/utils";

export const getImportSpecificationsQuery = gql(/* GraphQL */ `
  query ImportSpecifications($type: ImportSpecType, $caseTypeCode: String) {
    importSpecifications(type: $type, caseTypeCode: $caseTypeCode) {
      id
      name
    }
  }
`) as TypedDocumentNode<ImportSpecificationsQuery, ImportSpecificationsQueryVariables>;

export const useImportSpecificationsQuery = ({
  type,
  caseTypeCode,
  onError,
}: {
  type: ImportSpecType;
  caseTypeCode?: string;
  onError: (error: Error) => void;
}) => {
  return useFetchQuery(getImportSpecificationsQuery, {
    toData: (data) => {
      return data?.importSpecifications ?? [];
    },
    isEmpty: (data) => isEmpty(data?.importSpecifications),
    uiErrors: {
      fetchError: "FETCH-LIST-SPECIFICATIONS-ERROR",
    },
    queryOptions: {
      variables: {
        type,
        caseTypeCode,
      },
      onError,
      fetchPolicy: "no-cache",
      context: {
        uri: "/import-export-api/v1/private/graphql",
      },
    },
  });
};
